module.exports = __webpack_public_path__ + "img/cognitive_img03.b29bc6b0.png";